var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgWarning = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.5743 14.048L18.4374 2.90883C18.1495 2.62071 17.8076 2.39215 17.4312 2.23621C17.0549 2.08026 16.6516 2 16.2442 2C15.8369 2 15.4335 2.08026 15.0572 2.23621C14.6809 2.39215 14.339 2.62071 14.051 2.90883L2.90883 14.048C2.62071 14.336 2.39215 14.6779 2.23621 15.0542C2.08026 15.4305 2 15.8339 2 16.2412C2 16.6485 2.08026 17.0519 2.23621 17.4282C2.39215 17.8045 2.62071 18.1464 2.90883 18.4344L14.048 29.5743C14.336 29.8624 14.6779 30.091 15.0542 30.2469C15.4305 30.4029 15.8339 30.4832 16.2412 30.4832C16.6485 30.4832 17.0519 30.4029 17.4282 30.2469C17.8045 30.091 18.1464 29.8624 18.4344 29.5743L29.5743 18.4374C29.8629 18.1494 30.0918 17.8073 30.2481 17.4307C30.4043 17.0541 30.4847 16.6504 30.4847 16.2427C30.4847 15.835 30.4043 15.4313 30.2481 15.0547C30.0918 14.6781 29.8629 14.336 29.5743 14.048ZM28.3197 17.1797L17.179 28.3197C16.9304 28.5678 16.5936 28.7072 16.2423 28.7072C15.8911 28.7072 15.5542 28.5678 15.3057 28.3197L4.16879 17.1797C3.92065 16.9312 3.78128 16.5943 3.78128 16.2431C3.78128 15.8919 3.92065 15.555 4.16879 15.3064L15.3057 4.16954C15.5542 3.92141 15.8911 3.78204 16.2423 3.78204C16.5936 3.78204 16.9304 3.92141 17.179 4.16954L28.3197 15.3057C28.5678 15.5542 28.7072 15.8911 28.7072 16.2423C28.7072 16.5936 28.5678 16.9304 28.3197 17.179V17.1797Z",
    fill: "#ED7000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7906 19.1429L17.3268 13.1918V9.12305H15.1562V13.191L15.6924 19.1422L16.7906 19.1429Z",
    fill: "#ED7000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4262 20.9473H15.0605V23.3636H17.4262V20.9473Z",
    fill: "#ED7000"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgWarning);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/warning.e3d887edcca8aa9e42039a5821839d74.svg";